<template>
  <svg
    class="footer-arrow"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.142 20.1537C15.5416 20.7106 16.4585 20.7106 16.8582 20.1537L22.1251 12.8147C22.556 12.2142 22.0696 11.4286 21.267 11.4286H10.7331C9.93053 11.4286 9.44413 12.2142 9.87502 12.8147L15.142 20.1537Z"
      fill="#FCFCFC"
    />
  </svg>
</template>
<script>
export default {
  name: 'FooterArrow'
}
</script>
<style lang="sass" scoped>
.footer-arrow
  fill: currentColor
</style>
